import React, { useState, useEffect, Fragment } from "react";

import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import { Divider } from "primereact/divider";
import { MultiSelect } from "primereact/multiselect";

import InputNumberUI from "@UI/InputNumberUI";

import { changeValByPath } from "@utils";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const CopyCompany = inject("mainStore")(
    observer(({ mainStore, refClose }) => {
        const modal = computed(() => mainStore.getMainStore("modal")).get();
        const [sites, setSites] = useState([]);
        const [sorts, setSorts] = useState([]);
        const [state, setState] = useState([]);

        const copyItems = modal && modal.copyItems ? modal.copyItems : false;

        useEffect(() => {
            getSites();
        }, []);

        useEffect(() => {
            if (!sorts.length && copyItems?.length) {
                const arr = copyItems.reduce((acc, row) => [...acc, { offerId: row._id, siteId: "", sort: 0 }], []);
                setSorts(arr);
            }
        }, [copyItems]);

        const changeHandler = (e) => {
            setState(e.value);
        };

        const getSites = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&project[archived]=1&filters[active]=true", false, "", false, false);

            if (resp && resp.success) {
                setSites(resp.data);
                return;
            }
        };

        const saveHandler = async () => {
            const data = [];
            state.forEach((st) => sorts.forEach((so) => data.push({ ...so, siteId: st._id })));
            console.log("add sort data", data);

            const respSort = await mainStore.postByUrl("/promo/offerbysitesortsmany", { data });
            if (respSort.success) {
                modal.setSelectedItems();
                mainStore.setMainStore("toast", { severity: "success", summary: "Все офферы привязаны к новым витринам" });
                mainStore.setMainStore("modal", false);
            }
        };

        return (
            sorts &&
            sorts.length && (
                <div className="copyItems" ref={refClose}>
                    <div className="copyItems__text">
                        <div className="copyItems__list">
                            {sorts.map((m, idx) => (
                                <Fragment key={idx}>
                                    <span>{`${idx + 1}. ${copyItems?.[idx]?.technicalName}`}</span>
                                    <div className="copyItems__sort-block">
                                        <span>Sort*</span>
                                        <InputNumberUI value={m.sort} onChange={(e) => setSorts((prev) => changeValByPath(`${idx}.sort`, e.value, prev))} placeholder="" />
                                    </div>
                                </Fragment>
                            ))}
                        </div>
                    </div>
                    <Divider />
                    <div className="copyItems__inputs">
                        <span>Выберите витрины к которым нужно привязать офферы*</span>
                        <MultiSelect
                            filter
                            showClear={true}
                            value={state}
                            onChange={(e) => changeHandler(e)}
                            options={sites}
                            optionLabel={"name"}
                            placeholder={"Введите название сайта"}
                            emptyFilterMessage={"Нет элементов для выбора"}
                            emptymessage={"Нет элементов для выбора"}
                            emptyMessage={"Нет элементов для выбора"}
                            className="copyItems__inputs-dropdown"
                            display="chip"
                        />
                    </div>
                    <div className="copyItems__buttons">
                        <ButtonUI label={`Привязать офферы`} severity="info" raised onClick={saveHandler} disabled={!state?.length} />
                    </div>
                </div>
            )
        );
    }),
);

export default CopyCompany;
